<template>
  <div id="chart" class="wrapper-chart">
    <h3>Tempo Médio de Espera por Fila (Telefonia)</h3>
    <apexchart
      ref="chart_ref"
      type="bar"
      height="450"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import momentDuration from 'moment-duration-format'
momentDuration(moment)

export default {
  props: ['type', 'filter'], // pode manter, mas não é mais usado para alternar
  data () {
    return {
      startDateAvg: moment().format('YYYY-MM-DD 00:00:00'),
      endDateAvg: moment().format('YYYY-MM-DD 23:59:59'),
      series: [{ data: [] }],
      chartOptions: {
        chart: { type: 'bar', height: 350 },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: false, // << agora em pé
            dataLabels: { position: 'top' }
          }
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: [] // << apenas nomes das filas no eixo X
        },
        yaxis: {
          labels: {
            formatter: (value) => this.formatDuration(value) // << formatação no eixo Y
          }
        },
        tooltip: {
          y: {
            formatter: (value) => this.formatDuration(value),
            title: { formatter: () => 'Tempo Médio: ' }
          }
        },
        noData: { text: 'Sem dados para exibir no momento...' },
        colors: ['#008FFB', '#FEB019', '#00E396', '#FF4560', '#ffd60a', '#775DD0', '#7f4f24', '#00f5d4', '#4d194d', '#333533'] // paleta do waitingTime
      }
    }
  },
  methods: {
    formatDuration (sec) {
      return sec >= 86400
        ? moment.duration(sec, 'seconds').format('hh:mm:ss').replace(',', '.')
        : moment.utc(sec * 1000).format('HH:mm:ss')
    },
    getCallsAverage (event) {
      event && event.preventDefault()

      // << sempre busca o TEMPO DE ESPERA
      const url = 'averageWaitingTime'

      axios.get(`${window.location.href}/${url}?queue=${this.filter}`)
        .then(({ data }) => {
          const sorted = (data || []).slice().sort((a, b) => (b.average ?? 0) - (a.average ?? 0))
          this.chartOptions.xaxis.categories = sorted.map(el => el.queuename.toUpperCase())
          this.series[0].data = sorted.map(el => el.average)
          this.$refs.chart_ref.refresh()
        })
    }
  },
  beforeMount () {
    this.getCallsAverage()
    setInterval(() => { this.getCallsAverage() }, 30000)
  },
  watch: {
    filter () { this.getCallsAverage() }
  }
}
</script>

<style>
#btnSubmitAvg { margin-top: 33px; }
.wrapper-chart { width: 90%; margin-top: 50px; }
</style>
